export default "__VITE_ASSET__Bcgp8oRn__"